var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisputeCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.7,
    height: 48.7,
    viewBox: "0 0 48.7 48.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M49.263,24.913A24.35,24.35,0,1,1,24.913.563,24.35,24.35,0,0,1,49.263,24.913ZM22.1,37.806,40.162,19.74a1.571,1.571,0,0,0,0-2.222L37.941,15.3a1.571,1.571,0,0,0-2.222,0L20.985,30.03l-6.879-6.879a1.571,1.571,0,0,0-2.222,0L9.663,25.373a1.571,1.571,0,0,0,0,2.222L19.874,37.806a1.571,1.571,0,0,0,2.222,0Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeCheckIcon);
export default __webpack_public_path__ + "static/media/DisputeCheckIcon.68ef8e0fc8daa23bbd0a697c18816974.svg";
export { ForwardRef as ReactComponent };